import { Button, Checkbox, Col, Form, Input, Radio, Row, Select, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import useOperationTypes from '../../apis/operationTypesAPI';
import EventEmitter from '../../../utils/eventEmitter';
import { RxUpdate } from 'react-icons/rx';


const types = [
  {value: 'receipt', label: 'Receipt'},
  {value: 'delivery', label: 'Delivery'},
  {value: 'internal_transfer', label: 'Internal Transfer'},
];

const backorders = [
  {value: 'ask', label: 'Ask'},
  {value: 'always', label: 'Always'},
  {value: 'never', label: 'Never'}
];

const OperationTypeChanges = () => {
  const {locations, warehouses, operation} = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(operation.name ? operation.name : '');
  const { create, update } = useOperationTypes();

  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    let short_name = form.getFieldValue('warehouse');
    data['name'] = name;
    let seo = name.toLowerCase().replace(/ /g, '-');
    if (short_name) {
      data['seo'] = `${short_name.toLowerCase()}-${seo}`;
    }
    // data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    let short_name = form.getFieldValue('warehouse');
    data['name'] = name;
    let seo = name.toLowerCase().replace(/ /g, '-');
    data['id'] = operation.id;
    if (short_name) {
      data['seo'] = `${short_name.toLowerCase()}-${seo}`;
    }else {
      let warehouse = warehouses.find(warehouse => warehouse.id === data.warehouse_id);
      let short_name_ = warehouse.short_name.toLowerCase();
      data['seo'] = `${short_name_}-${seo}`;
    }
    update(operation.seo, data, success);
  };

  useEffect(() => {
    EventEmitter.subscribe('operation_response', data => {
      navigate('/inventory/operation-types/'+data);
    });
    
    return () => EventEmitter.unsubscribe('operation_response');
  },[])

  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className=''>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/operation-types'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Operation-Types</Link> / {params.action}
          </h3>
          <Tooltip title='save manually' placement='rightBottom' className='ms-1'>
            <Button type='text' htmlType='button' onClick={handleSave}
              disabled={ operation.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          <Tooltip title='edit' placement='rightBottom' className='ms-1'>
            <Button type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip>
        </div>
        {operation.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          name='name'
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Operation Type Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form name="operation"
          form={form}
          labelAlign='left'
          labelCol={{ span: 10 }}
          labelWrap={true}
          initialValues={operation.seo ? operation : {
            show_detailed_operations: false,
            preFill_detailed_operations: false
          }}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Tabs
            className='mt-3'
            type='card'
            items={[
              {
                key: 1,
                label: 'General',
                children:
                  <>
                    <Row>
                      <Col lg={{ span: 10 }}>
                        {/* <Badge className="text-slate-500 text-xl bg-transparent	border-b-2 mb-3">SHIPMENTS</Badge> */}
                        <Form.Item label='Type' name="type" className='font-semibold text-gray-800 mb-3' required >
                          <Select options={types}/>
                        </Form.Item>
                        <Form.Item label='Reference Sequence' name="reference_sequence" className='font-semibold text-gray-800 mb-2 column' required >
                          <Input type='text' className='border-x-0 border-t-0 input-outline-none font-normal w-full'/>
                        </Form.Item>
                        {/* <Form.Item label='Barcode' name="barcode" className='font-semibold text-gray-800 mb-2 column' required >
                          <Input type='text' className='border-x-0 border-t-0 input-outline-none font-normal'/>
                        </Form.Item> */}
                        <Form.Item label='Warehouse' name="warehouse_id" className='font-semibold text-gray-800 mb-2 column' required >
                          <Select options={warehouses.map(warehouse => ({value: warehouse.id, label: warehouse.name, short: warehouse.short_name}))} onChange={(v, opt) => form.setFieldValue('warehouse', opt.label)}/>
                        </Form.Item>
                      </Col>
                      <Col lg={{span: 11, offset: 1}}>
                        {/* <Badge className="text-slate-500 text-xl bg-transparent	border-b-2 mb-3">RESUPPLY</Badge> */}
                        <Form.Item labelCol={{span: 12}} label='Return Type' name='return_type' className='font-semibold text-gray-800 mb-3' required>
                          <Input type='text' className='border-x-0 border-t-0 input-outline-none font-normal w-full'/>
                        </Form.Item>
                        <Form.Item labelCol={{span: 12}} label='Create Backorder' name='backorder' className='font-semibold text-gray-800 mb-3' required>
                          <Select options={backorders} className='w-full'/>
                        </Form.Item>
                        <Form.Item labelCol={{span: 12}} label='Show Detailed Operations' name='show_detailed_operations' valuePropName='checked' className='font-semibold text-gray-800 mb-3' required>
                          <Checkbox />
                        </Form.Item>
                        <Form.Item labelCol={{span: 12}} label='Pre-fill Detailed Operations' name='preFill_detailed_operations' valuePropName='checked' className='font-semibold text-gray-800 mb-3' required>
                          <Checkbox />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={{span: 10}}>
                        <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">TRACEABILITY</Badge>
                        <Form.Item labelCol={{span: 12}} label='Create New Lots/Serial Numbers' name='create_lot_serial_number' valuePropName='checked' className='font-semibold mb-3' required>
                          <Checkbox />
                        </Form.Item>
                        <Form.Item labelCol={{span: 12}} label='Use Existing Lots/Serial Numbers' name='use_lot_serial_number' valuePropName='checked' className='font-semibold mb-3' required>
                          <Checkbox />
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">PACKAGES</Badge>
                        <Form.Item labelCol={{span: 12}} label='Move Entire Packages' name='move_entire_packages' valuePropName='checked' className='font-semibold mb-3' required>
                          <Checkbox />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={{span: 10}}>
                        <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">LOCATIONS</Badge>
                        <Form.Item labelCol={{span: 12}} label='Default Source Location' name='source_location' className='font-semibold text-gray-800 mb-3' required>
                          <Select options={locations.map(location => ({value: location.id, label: location.name}))} className='w-full'/>
                        </Form.Item>
                        <Form.Item labelCol={{span: 12}} label='Default Destination Location' name='destination_location' className='font-semibold text-gray-800 mb-3' required>
                          <Select options={locations.map(location => ({value: location.id, label: location.name}))} className='w-full'/>
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
              },
              // {
              //   key: 2,
              //   label: 'Technical Information',
              // }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default OperationTypeChanges;